import axiosInstance from "./httpInterceptor";

// Only track in production
const ENABLE_TRACKING = process.env.NODE_ENV === "production";

export const analyticsService = {

  /**
   * Track a page view
   * @param {string} page - The page being viewed
   * @param {object} parameters - Additional parameters
   */
  trackPageView: async (page, parameters = {}) => {

    // Skip tracking if disabled
    if (!ENABLE_TRACKING) {
      return;
    }

    try {
      await axiosInstance.post("/v1/audit/page-view", {
        page,
        parameters,
      });
    } catch (error) {
      console.error("page view issue:", error);
    }
  },
};
